const SET_LOADER_PROGRESS = "loader::set::progress";
const INCREMENT_LOAD_COUNT = "loader::load-count::increment";
const SET_LOADER_TEXT = "loader::set::text";

function setLoaderStatusAction(isLoading) {
  return {
    payload: { loadCount: isLoading ? 1 : -1 },
    type: INCREMENT_LOAD_COUNT,
  };
}

function setLoaderProgressAction(progress) {
  return {
    payload: { progress },
    type: SET_LOADER_PROGRESS,
  };
}

function setLoaderTextAction(text) {
  const loaderText = typeof text === "string" ? text : null;

  return {
    payload: { loaderText },
    type: SET_LOADER_TEXT,
  };
}

export {
  SET_LOADER_PROGRESS,
  INCREMENT_LOAD_COUNT,
  SET_LOADER_TEXT,
  setLoaderProgressAction,
  setLoaderStatusAction,
  setLoaderTextAction,
};
